import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'
import { getToken } from '@/utils/auth'
import { Dialog } from 'vant'
import { MyNotify } from '@/utils/base'
import Cookies from 'js-cookie'

// import commonData from '@/commondata.js'
// create an axios instance
const service = axios.create({
  baseURL: GetServiceUrl(),
  // baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 500000, // request timeout
  paramsSerializer: function(params) {
    return qs.stringify(params, { indices: false })
  }, components: {
    [Dialog.name]: Dialog
  }
})
export function GetServiceUrl() {
  return 'https://apis.myssi.cn/userAPI/'
  // return 'http://39.98.166.57:1210/userAPI/' // 测试服务器
  // return 'https://localhost:44341/userAPI/' // 本机测试
  // return 'https://apis.myssi.cn/userAPI/' // 正式服务器
}
export function GetSelfUrl() {
  return 'https://m.myssi.cn/'
  // return 'http://ssitest.intotheblue.pro/' // 测试服务器
  // return 'http://192.168.2.51:8080/'  //本机测试
  // return 'https://m.myssi.cn/'  //正式服务器
}

// request interceptor
service.interceptors.request.use(
  async(config) => {
    var dc = Cookies.get('default_divecenter')
    if (dc) {
      config.headers['dc'] = dc
    }
    // 全完不需要权限
    if (config.url.indexOf('/user/GetWxLoginUrl') >= 0 ||
        config.url.indexOf('/user/wechatLogin') >= 0 ||
        config.url.indexOf('/data/getSSIBaseData') >= 0 ||
        config.url.indexOf('/data/getEnumList') >= 0 ||
        config.url.indexOf('/data/getAppDownload') >= 0) {
      return config
    }
    // 可要可不要微信登录
    if (config.url.indexOf('/Activity/GetCardTeam') >= 0 ||
      config.url.indexOf('/Activity/getWxShare') >= 0) {
      if (getToken() !== undefined) {
        token = getToken().token
        if (token) {
          config.headers['SSIToken'] = token
        }
      }
      return config
    }

    // if (commonData.ssiBase === undefined) {
    //   await store.dispatch('user/getSSIBaseData')
    // }
    // if (commonData.enumList === undefined) {
    //   await store.dispatch('user/getEnumList')
    // }

    var token// store.getters.token
    if (getToken() !== undefined) {
      token = getToken().token
    }
    // token = 'eyJ1IjozMywibiI6bnVsbCwiZSI6IjIwMTktMDYtMDdUMDE6MTQ6MjUuNTY2ODMzNVoiLCJzIjoiNjg5RkQ5MjNFQ0VFMDdENDQ4MzZFNkNGRTgwNzE3QkI3RUI1N0Y2MjQ5MTcwRkY0RUI2MjQ1OThFRTgwRjlCOCIsInQiOjEsIm8iOiJvUVlmcjVtUE1NYmNMMXpxSUpiaEJxVmxwbFhRIn0='
    if (token) {
      config.headers['SSIToken'] = token
      console.log('请求时Token', token)
    } else {
      // 跳转出去进行微信登录
      var Backrouter = router.history.current.fullPath
      var url = GetSelfUrl() + 'loginCallback?url=' + Backrouter
      await store.dispatch('user/getWxLoginUrl', url).then(response => {
        console.log('跳转页面去登录', response)
        window.location.href = response
      })
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if (response.config.url.indexOf('/data/getArea') >= 0) {
      return response.data
    }
    const res = response.data
    console.log('网络反馈结构', res)
    if (res.code !== 0) {
      MyNotify('error', res.message || 'error')
    }
    if (res.code === 1001) {
      Dialog.alert({
        title: '重新登录',
        message: '因为一些原因，您已经掉线，现在需要重新登录'
      }).then(() => {
        // 跳转出去进行微信登录
        var Backrouter = router.history.current.fullPath
        var url = GetSelfUrl() + 'loginCallback?url=' + Backrouter
        store.dispatch('user/getWxLoginUrl', url).then(response => {
          console.log('跳转页面去登录', response)
          window.location.href = response
        })
      })
    } else if (res.code === 1005) {
      router.replace('/users/regPhone?url=' + router.history.current.fullPath)
    } else if (res.code === 1006) {
      router.replace('/users/bindSSI?url=' + router.history.current.fullPath)
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)

export default service
